import {MeasurementUnitFormTemplate} from "./MeasurementUnitFormTemplate";

export function MeasurementUnitFormCreate() {
    return (
        <MeasurementUnitFormTemplate buttonName={"Создать"}/>
    )
}